import {
  put,
  takeLatest,
  takeEvery,
  call,
  all,
  delay,
} from 'redux-saga/effects'
import { Action } from 'redux'
import Cookies from 'js-cookie'
import * as Sentry from '@sentry/react'

import * as errorHandler from 'utils/error-handler'
import { UserActionsTypes } from './actions'
import * as api from './api'

const OLD_DASHBOARD_AUTH_REDIRECT_URL =
  process.env.REACT_APP_OLD_DASHBOARD_AUTH_REDIRECT_URL

// @ts-ignore
const initUser = function* (action) {
  try {
    const referralParamClickId = Cookies.get('referral_param_click_id')

    if (action.isFirstLogin && !!referralParamClickId) {
      Cookies.remove('referral_param_click_id')
    }

    if (action.isFirstLogin) yield delay(4000)

    // @ts-ignore
    const userInitResponse = yield call(
      api.initUser,
      action.isFirstLogin ? referralParamClickId : undefined,
      action.forceNewDash && action.isFirstLogin
        ? action.forceNewDash
        : undefined
    )

    /*const [balanceResponse, subscriptionResponse] = yield all([
      call(api.getUserBalance),
      call(api.getUserSubscription),
    ])*/

    if (userInitResponse.data.is_old_user) {
      window.location.replace(
        `${OLD_DASHBOARD_AUTH_REDIRECT_URL}${userInitResponse.data.token}`
      )
    } else {
      const { data } = yield call(api.getUserOverview)

      yield all([
        put({
          type: UserActionsTypes.USER_GET_OVERVIEW_SUCCESS,
          userCustomerView: data.customer_view,
          userSubscriptionView: data.subscription_view,
          userBalanceView: data.balance_view,
          userScrapperView: data.scrapper_view,
          userProxyView: data.proxy_view,
        }),
        put({
          type: UserActionsTypes.USER_INITIALIZE_SUCCESS,
          intercomHash: userInitResponse.data.intercom_hash,
          userHash: userInitResponse.data.user_hash,
        }),
      ])
    }
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_INITIALIZE_FAIL },
      e,
      { section: 'UserInitializeError' },
      {
        userId: action.userId,
      }
    )
    yield put(handledAction)
  }
}

const getUserOverview = function* () {
  try {
    const { data } = yield call(api.getUserOverview)

    yield put({
      type: UserActionsTypes.USER_GET_OVERVIEW_SUCCESS,
      userCustomerView: data.customer_view,
      userSubscriptionView: data.subscription_view,
      userBalanceView: data.balance_view,
      userScrapperView: data.scrapper_view,
      userProxyView: data.proxy_view,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_OVERVIEW_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getUserBalance = function* () {
  try {
    const { data } = yield call(api.getUserBalance)

    yield put({
      type: UserActionsTypes.USER_GET_BALANCE_SUCCESS,
      balanceInfo: {
        balance: data.balance,
        accrued: data.accrued,
        creditSum: data.credit_sum,
      },
      userStatsUrl: data.portal_url,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_BALANCE_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getUserStatsUrl = function* () {
  try {
    const { data } = yield call(api.getUserStatsUrl)

    yield put({
      type: UserActionsTypes.USER_GET_STATS_URL_SUCCESS,
      userStatsUrl: data.portal_url,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_STATS_URL_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getScrapperApiKey = function* () {
  try {
    const { data } = yield call(api.getScrapperApiKey)

    yield put({
      type: UserActionsTypes.USER_GET_SCRAPPER_API_KEY_SUCCESS,
      scrapperApiKey: data.scrapper,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_SCRAPPER_API_KEY_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getProxyPackages = function* () {
  try {
    /*const [proxyPackagesResponse, availableHostsResponse] = yield all([
      call(api.getProxyPackages),
      call(api.getAvailableHosts),
    ])*/

    const { data } = yield call(api.getProxyPackages)

    /*yield put({
      type: UserActionsTypes.USER_GET_PROXY_PACKAGES_SUCCESS,
      proxyPackages: proxyPackagesResponse.data,
      availableHosts: availableHostsResponse.data,
    })*/

    yield put({
      type: UserActionsTypes.USER_GET_PROXY_PACKAGES_SUCCESS,
      proxyPackages: data,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_PROXY_PACKAGES_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getUserSubscription = function* () {
  try {
    const { data } = yield call(api.getUserSubscription)

    yield put({
      type: UserActionsTypes.USER_GET_SUBSCRIPTIONS_SUCCESS,
      subscriptionInfo: data,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: UserActionsTypes.USER_GET_SUBSCRIPTIONS_FAIL },
      e
    )
    yield put(handledAction)
  }
}

function* userSaga() {
  yield takeLatest(UserActionsTypes.USER_INITIALIZE, initUser)
  yield takeLatest(UserActionsTypes.USER_GET_OVERVIEW, getUserOverview)
  yield takeLatest(UserActionsTypes.USER_GET_STATS_URL, getUserStatsUrl)
  yield takeLatest(UserActionsTypes.USER_GET_BALANCE, getUserBalance)
  yield takeEvery(UserActionsTypes.USER_GET_SUBSCRIPTIONS, getUserSubscription)
  yield takeLatest(
    UserActionsTypes.USER_GET_SCRAPPER_API_KEY,
    getScrapperApiKey
  )
  yield takeLatest(UserActionsTypes.USER_GET_PROXY_PACKAGES, getProxyPackages)
}

export default userSaga
